/**
 * @deprecated in favour of basic Modal
   
/**
 * Modal Component.
 * Author: @tejasupmanyu
 */
import { Modal } from "antd";
export default Modal;
//# sourceMappingURL=modal.js.map